import {
  ASSET_BROKEN_STATES,
  ASSET_DESIRED_STATES,
  ASSET_OPERATIONAL_STATES,
  CURRENT_PROGRAM,
  type CurrentProgramId,
} from '../hooks/useWatchSocket';

export type GeneratorDiagramStatus = 'ACTIVE' | 'BUSY' | 'ERROR' | 'IDLE' | 'UNKNOWN';

export const ASSET_LOCATIONS = {
  INPUT: 'input',
  OUTPUT: 'output',
} as const;

export type AssetLocation = (typeof ASSET_LOCATIONS)[keyof typeof ASSET_LOCATIONS];

//  Island, Cycle, Loadshare, Peakshave
export const OUTPUT_LOCATION_PROGRAMS: CurrentProgramId[] = [
  CURRENT_PROGRAM.GRID_PEAKSHAVE,
  CURRENT_PROGRAM.GEN_SET_PEAKSHAVE,
  CURRENT_PROGRAM.GEN_SET_CYCLE,
  CURRENT_PROGRAM.LOADSHARE,
  CURRENT_PROGRAM.GEN_SET_NIGHT_MODE,
  CURRENT_PROGRAM.STANDALONE,
  CURRENT_PROGRAM.CHARGE_ON_GENSET,
  CURRENT_PROGRAM.CHARGE_ON_GRID,
];

// Microgrid, Droop, AFE
export const INPUT_LOCATION_PROGRAMS: CurrentProgramId[] = [
  CURRENT_PROGRAM.DROOP_SINGLE,
  CURRENT_PROGRAM.DROOP,
  CURRENT_PROGRAM.AFE_CLUSTER,
  CURRENT_PROGRAM.CLUSTER_AFE_CHARGE,
  CURRENT_PROGRAM.CHARGE_ON_GRID_VS_AFE,
  CURRENT_PROGRAM.CLUSTER_DROOP_DISCHARGE,
  CURRENT_PROGRAM.ADD_TO_DROOP_CLUSTER,
  CURRENT_PROGRAM.GRID_BOOST,
  CURRENT_PROGRAM.CLUSTER_DROOP_PASSIVE_DISCHARGE,
  CURRENT_PROGRAM.CLUSTER_STANDBY,
  CURRENT_PROGRAM.CLUSTER_TRANSPORT_DEPARTURE,
  CURRENT_PROGRAM.CLUSTER_TRANSPORT_ARRIVAL,
];

export const OPERATIONAL_STATE_LABELS: Record<number, string> = {
  [ASSET_OPERATIONAL_STATES.UNKNOWN]: 'stateUnknown',
  [ASSET_OPERATIONAL_STATES.IDLE]: 'operationalStateIdle',
  [ASSET_OPERATIONAL_STATES.WARMING_UP]: 'operationalStateWarmingUp',
  [ASSET_OPERATIONAL_STATES.RAMPING_UP]: 'operationalStateRampingUp',
  [ASSET_OPERATIONAL_STATES.RUNNING]: 'operationalStateRunning',
  [ASSET_OPERATIONAL_STATES.RAMPING_DOWN]: 'operationalStateRampingDown',
};

export const BROKEN_STATE_LABELS: Record<number, string> = {
  [ASSET_BROKEN_STATES.UNKNOWN]: 'stateUnknown',
  [ASSET_BROKEN_STATES.NOT_BROKEN]: 'brokenStateNotBroken',
  [ASSET_BROKEN_STATES.CONNECTION_IMPAIRED]: 'brokenStateConnectionImpaired',
  [ASSET_BROKEN_STATES.BROKEN]: 'brokenStateBroken',
};

export const DESIRED_STATE_LABELS: Record<number, string> = {
  [ASSET_DESIRED_STATES.OFF]: 'desiredStateOff',
  [ASSET_DESIRED_STATES.ON]: 'desiredStateOn',
  [ASSET_DESIRED_STATES.AUTO]: 'desiredStateAuto',
};
